import { useState } from "react";
import { SelfIdentificationForm } from "@components/self_identification_form.tsx";
import type { SelfIdentification } from "@/utils/self_identification.ts";
import ModalFooter from "./modal_footer.tsx";
import useSectionSave from "./use_section_save.ts";
import type { SectionProps } from "./types.ts";

const SelfIdentificationSection = ({ data, onClose, source }: SectionProps) => {
  const { save, saving } = useSectionSave();
  const [value, setValue] = useState<SelfIdentification>(data.selfIdentification?.value || {});

  const handleSave = async () => {
    const formData = new FormData();
    formData.append(
      "self_identification[disability_status]",
      value.disabilityStatus?.toString() || "",
    );
    formData.append("self_identification[gender]", value.gender?.toString() || "");
    formData.append("self_identification[race]", value.race?.toString() || "");
    formData.append("self_identification[veteran_status]", value.veteranStatus?.toString() || "");

    const success = await save(formData);
    if (success) onClose();
    return success;
  };

  return (
    <>
      <SelfIdentificationForm
        details={data.selfIdentification.details}
        options={data.selfIdentification.options}
        value={value}
        onChange={setValue}
      />
      <ModalFooter
        section="voluntary_self_id"
        onSave={handleSave}
        onCancel={onClose}
        saving={saving}
        source={source}
      />
    </>
  );
};

export default SelfIdentificationSection;
